export default "__VITE_ASSET__Sbjrvr5n__"